import Vue from 'vue';
import Router from 'vue-router';
import * as dd from 'dingtalk-jsapi'

const page404 = () => import('@/view/404.vue')

Vue.use(Router);

const routes = [
  {
    path: '*',
    redirect: '/index'
  },
  {
    name: 'index',
    component: () => import('@/view/index'),
    meta: {
      title: '',
      isOpen: true
    }
  },
  {
    name: 'redirect',
    component: () => import('@/view/redirect'),
    meta: {
      title: '转移持单人',
      isOpen: true
    }
  },
  // {
  //   path: '/login',
  //   name: 'login',
  //   meta: {
  //     title: '登录',
  //     isOpen: true
  //   },
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import('@/view/Login.vue')
  // },
  {
    path: '*',
    name: 'page404',
    meta: {
      title: '页面未找到'
    },
    component: page404
  }
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});
routes.mode = 'history'
const router = new Router({ 
  // mode: 'history',
  routes 
});

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  if (dd.env.platform!=="notInDingTalk") {
  dd.biz.navigation.setTitle({
    title : '',//控制标题文本，空字符串表示显示默认文本
    // title : title,//控制标题文本，空字符串表示显示默认文本
    // onSuccess : function(result) {
    //     /*结构
    //     {
    //     }*/
    // },
    // onFail : function(err) {}
  });
} 
  next();
});

export {
  router
};
